import { useEffect, useRef } from 'preact/hooks'

export const useEffectSkipFirst = (fn, deps) => {
  const first = useRef(true)

  useEffect(() => {
    if (first.current) {
      first.current = false
    } else {
      return fn()
    }
  }, deps)
}
